import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BioDescription } from './../TabsContent/BioTabs';
import { ArzatorAltepDescription } from './../TabsContent/ArzatorAltepTabs';
import { BioUniDescription } from './../TabsContent/BioUniTabs';
import { ClasicPlusDescription } from './../TabsContent/ClassicPlusTabs';
import { DuoPelletDescription } from './../TabsContent/DuoPelletTabs';
import { DuoPelletNDescription } from './../TabsContent/DuoPelletNTabs';
import { DuoUniPlusDescription } from './../TabsContent/DuoUniPlusTabs';
import { DuoUniPelletDescription } from './../TabsContent/DuoUniPelletTabs';
import { DuoUniPelletPlusDescription } from './../TabsContent/DuoUniPelletPlusTabs';
import { MaxDescription } from './../TabsContent/MaxTabs';
import { MegaDescription } from './../TabsContent/MegaTabs';
import { TrioDescription } from './../TabsContent/TrioTabs';
import { TermoAcumulatorTAPDescription } from './../TabsContent/TermoAcumulatorTAPTabs';
import { TermoAcumulatorTA0Description } from './../TabsContent/TermoAcumulatorTA0Tabs';
import { TrioPelletDescription } from './../TabsContent/TrioPelletTabs';
import { TrioUniPelletDescription } from '../TabsContent/TrioUniPelletTabs';
import { TrioUniPelletPlusDescription } from '../TabsContent/TrioUniPelletPlusTabs';
import { TrioUniPlusDescription } from '../TabsContent/TrioUniPlusTabs';
import { TurboDescription } from '../TabsContent/TurboTabs';
import { AltepPelletsDescription } from '../TabsContent/AltepPelletsTabs';
import { AgroDescription } from '../TabsContent/AgroTabs';

const Description = (props) => {
  switch (props.productId) {
    case 0:
      return <ArzatorAltepDescription />
    case 1:
      return <BioDescription />
    case 2:
      return <BioUniDescription />
    case 4:
      return <ClasicPlusDescription />
    case 5:
      return <DuoPelletDescription />
    case 6:
      return <DuoPelletNDescription />
    case 7:
      return <DuoUniPlusDescription />
    case 8:
      return <DuoUniPelletDescription />
    case 9:
      return <DuoUniPelletPlusDescription />
    case 10:
      return <MaxDescription />
    case 11:
      return <MegaDescription />
    case 12:
      return <TrioDescription />
    case 13:
      return <TermoAcumulatorTAPDescription />
    case 15:
      return <TermoAcumulatorTA0Description />
    case 16:
      return <TrioPelletDescription />
    case 17:
      return <TrioUniPelletDescription />
    case 18:
      return <TrioUniPelletPlusDescription />
    case 19:
      return <TrioUniPlusDescription />
    case 20:
      return <TurboDescription />
    case 21:
      return <AltepPelletsDescription />
    case 22:
      return <AgroDescription />
    default:
      return <></>
  }
};

export default Description;
